<script setup>
const props = defineProps({
    textRight: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: ''
    },
    paragraphs: {
        type: Array,
        default: () => []
    },
    image: {
        type: Object,
        default: () => ({})
    }
})

const imageSource = (src) => {
    return String(src).replace('.jpg', '-full.jpg')
}

const form = ref({})
import {useEditableArray} from "@/composables/editableArray.js";

const fillForm = () => {
    form.value = {
        title: props.title,
        image: props.image,
        paragraphs: useEditableArray(props.paragraphs).items
    }
}
onMounted(() => {
    fillForm()
})
</script>

<template>
    <section class="my-52 lg:py-30">
        <div class="container px-4 mx-auto">
            <div class="grid md:grid-cols-2 gap-12">
                <div>
                    <h2 class="font-semibold text-4xl text-black space-x-3 mb-2"
                        v-editable="form.title"
                    />

                    <slot name="default">
                        <p v-for="(paragraph, index) in form.paragraphs"
                           class="text-lg text-gray-600 mb-4"
                           :key="paragraph.id"
                           v-editable-items="{ array: paragraphs, index }"
                        />
                    </slot>
                </div>

                <div :class="['grid sm:grid-cols-2 gap-4', {'md:order-first': textRight}]">
                    <slot name="extra">
                        <template v-if="image.src">
                            <img :src="imageSource(image.src)"
                                 :alt="image.alt"
                                 class="rounded-lg shadow-lg col-span-2"
                            >
                        </template>
                    </slot>
                </div>
            </div>

        </div>
    </section>
</template>
